/**
 * Lead section provider for Global Search (list API → SearchHit).
 */

import { formatPersonName } from '@/shared/utils/personName';
import type { GlobalSearchSectionProvider } from '@/shared/search/types';
import { leadAPI } from '../api/lead.api';

export const leadSearchProvider: GlobalSearchSectionProvider = {
  id: 'leads',
  permission: 'leads:read',
  titleKey: 'globalSearchLeads',
  iconId: 'leads',
  rankByAcronym: true,
  search: async (query, { limit, signal }) => {
    const res = await leadAPI.getAll(
      { search: query, limit },
      { signal },
    );
    return (res.data ?? []).slice(0, limit).map((lead) => ({
      id: lead.id,
      sectionId: 'leads',
      primary: lead.name || formatPersonName(lead) || lead.leadCode || lead.id,
      secondary: [lead.leadCode, lead.phone].filter(Boolean).join(' · ') || undefined,
      path: `/leads/${lead.id}`,
    }));
  },
};
